/**
 * Password:
 * Is Required
 * Minimum 8 characters
 * At least 1 Uppercase letter
 * At least 1 Lower Case letter
 * At least 1 Number At least 1 Special character
 *
 * @example registerOptions={{
        validate: (value) => {
          let errorMessage = null;
          passwordRules.forEach((rule) => {
            if (!rule.pattern.test(value)) {
              errorMessage = rule.message;
            }
          });
          return errorMessage || true;
        },
      }}
 *
 * @type {RegExp[]}
 */
export const passwordRules = [
  {
    pattern: /^.{8,}$/,
    message: 'Password should be at least 8 characters long.',
  },
  {
    pattern: /^(?=.*[a-z])/,
    message: 'Password should include at least one lowercase letter.',
  },
  {
    pattern: /^(?=.*[A-Z])/,
    message: 'Password should include at least one uppercase letter.',
  },
  {
    pattern: /^(?=.*\d)/,
    message: 'Password should include at least one number.',
  },
  {
    pattern: /^(?=.*[!@#$%^&*()\-_=+{};:,<.>])/,
    message: 'Password should include at least one special character.',
  },
  {
    pattern: /^(?!\s*$).+/,
    message: 'This field is required.',
  },
];

/**
 * Cellphone Number:
 * 0XXXXXXXXX
 * +XX XXXXXXXXXX
 * (XXX) XXXXXXXX
 * (XXXX) XXXXXXX
 * (XXXXX) XXXXXX
 * (XXXXXX) XXXXX
 *
 * @example registerOptions={{
        validate: (value) => {
          let errorMessage = null;
          cellphoneNumberRegex.forEach((rule) => {
            if (!rule.pattern.test(value)) {
              errorMessage = rule.message;
            }
          });
          return errorMessage || true;
        },
      }}
 *
 * @type {RegExp[]}
 */

export const cellphoneNumberRegex = [
  {
    pattern:
      /^(0\d{9,10}|[+]\d{1,3}\d{9,10}|\(\d{3}\)\d{7,8}|\(\d{4}\)\d{6,7})$/,
    message: 'Invalid cellphone number',
  },
];

/**
 * Email:
 *
 * @example registerOptions={{
        validate: (value) => {
          let errorMessage = null;
          emailRegex.forEach((rule) => {
            if (!rule.pattern.test(value)) {
              errorMessage = rule.message;
            }
          });
          return errorMessage || true;
        },
      }}
 *
 * @type {RegExp[]}
 */
export const emailRegex = [
  {
    pattern:
      /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
    message: 'Invalid email address',
  },
  {
    pattern: /^(?!\s*$).+/,
    message: 'This field is required.',
  },
];

/**
 * if the field is required only
 *
 * @example registerOptions={{
          required: requiredValidationMessage,
        }}
 *
 */
export const requiredValidationMessage = 'This field is required';

/**
 * if the field is required and must be a number
 *
 * @example registerOptions={{
          required: requiredValidationMessageWithNumber,
        }}
 *
 */
export const requiredValidationMessageWithNumber =
  'This field is required and must be a number';

/**
 * if the field is required only
 *
 * @example registerOptions={{
          required: requiredValidationMessage,
        }}
 *
 */
export const requiredValidationDropdownMessage = 'Please select an option';

/**
 * check if valid hex color
 *
 * @example registerOptions={{
        validate: (value) => {
          let errorMessage = null;
          colorRules.forEach((rule) => {
            if (!rule.pattern.test(value)) {
              errorMessage = rule.message;
            }
          });
          return errorMessage || true;
        },
      }}
 *
 * @type {RegExp[]}
 */
export const colorRules = [
  {
    pattern: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
    message: 'Invalid hex color',
  },
];

/**
 * URL validation:
 * Validates URLs with http/https protocols
 * Supports various URL formats including subdomains, ports, paths, query parameters
 *
 * @example registerOptions={{
        validate: (value) => {
          if (!value) return true; // Allow empty value (use required separately if needed)
          let errorMessage = null;
          urlValidationRules.forEach((rule) => {
            if (!rule.pattern.test(value)) {
              errorMessage = rule.message;
            }
          });
          return errorMessage || true;
        },
      }}
 *
 * @type {RegExp[]}
 */
export const urlValidationRules = [
  {
    pattern:
      /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)$/,
    message: 'Please enter a valid URL (e.g., https://example.com)',
  },
];
